import React from 'react';
import PropTypes from 'prop-types';
import { FORM_FIELDS } from './formFields';


const ProfileErrors = ({ errors, onErrorClick }) => {
  let errorItems = [];
  for (const [key, value] of Object.entries(errors)) {
    errorItems.push(<div><a href='#' onClick={ (e) => onErrorClick(e, key) }>{ FORM_FIELDS[key] }</a>: { value }</div>)
  }
  return <small>{ errorItems }</small>
}

ProfileErrors.PropTypes = {
  errors: PropTypes.object,
  onErrorClick: PropTypes.func.isRequired
}

export default ProfileErrors;

